import React, { useState } from "react";
import "./styles.css";
import InfoDialog from "../InfoDialog";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import CarouselControls from "../CarouselControls"; // importe ton composant réutilisable

export default function PagedCarousel({
  activities,
  refresh,
  selectCategory,
  isMainActivities = true,
  addActivity
}) {
  activities.sort((a, b) => a.name.localeCompare(b.name));

  const pageSize = 4;
  const [currentPage, setCurrentPage] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [activityToDelete, setActivityToDelete] = useState(null);

  const totalPages = Math.ceil(activities.length / pageSize);

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
  };

  const visibleActivities = activities.slice(
    currentPage * pageSize,
    currentPage * pageSize + pageSize
  );

  function confirmDeleteActivity(idActivity) {
    fetch(`https://intereseaux-api.bonnardwebeditions.fr/api/activities?id=${idActivity}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(async (response) => {
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || "Erreur lors de la suppression.");
        }
        return response.json();
      })
      .then(() => {
        refresh();
        setCurrentPage(0);
      })
      .catch((error) => {
        console.error("Erreur:", error);
      })
      .finally(() => {
        setDialogOpen(false);
        setActivityToDelete(null);
      });
  }

  return (
    <div className="carousel">
      <div className="carousel-container">
        <div className="carousel-page" key={currentPage}>
          {visibleActivities.length > 0 &&
            visibleActivities.map((activity) => (
              <div key={activity.id} className="card-main-activity">
                <div className="card-activity-header">{activity.name}</div>
                <div className="card-activity-controls">
                  {isMainActivities && (
                    <button
                      className="card-activity-button"
                      onClick={() => selectCategory(activity.id)}
                    >
                      <FontAwesomeIcon icon={faPen} />
                    </button>
                  )}
                  <button
                    className="card-activity-button"
                    onClick={() => {
                      setActivityToDelete(activity.id);
                      setDialogOpen(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                </div>
              </div>
            ))}

          {visibleActivities.length === 0 && (
            <p>
              {isMainActivities
                ? "Aucune activité principale enregistrée, cliquez sur le bouton plus pour en ajouter"
                : "Aucune sous-activité enregistrée pour cette activité, cliquez sur le bouton plus pour en ajouter"}
            </p>
          )}
        </div>
      </div>

      {/* Utilisation du composant CarouselControls */}
      <CarouselControls
        onPrev={handlePrev}
        onNext={handleNext}
        onAdd={() => addActivity(true)}
        isPrevDisabled={currentPage === 0}
        isNextDisabled={
          currentPage === totalPages - 1 || activities.length === 0
        }
      />

      <InfoDialog
        open={dialogOpen}
        title="Confirmation"
        message="Voulez-vous vraiment supprimer cette activité ?"
        onConfirm={() => confirmDeleteActivity(activityToDelete)}
        onCancel={() => {
          setDialogOpen(false);
          setActivityToDelete(null);
        }}
        confirmLabel="Oui, supprimer"
        cancelLabel="Annuler"
      />
    </div>
  );
}
